import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header_wrapper" }
const _hoisted_3 = {
  class: "pa-1",
  style: {"margin-top":"16px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_vue_loading = _resolveComponent("vue-loading")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_toolbar, {
        color: "primary",
        dark: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _ctx.routerBack,
            icon: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_toolbar_title, {
            style: {"position":"absolute","left":"50%","transform":"translateX(-50%)","margin":"0","padding":"0","max-width":"70%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"},
            class: "text-center"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.childName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            icon: "",
            disabled: "",
            style: {"visibility":"hidden"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_select, {
        modelValue: _ctx.selectedNendo,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedNendo) = $event)),
          _ctx.changeNendo
        ],
        items: _ctx.nendoOptions,
        label: "年度",
        variant: "outlined",
        "hide-details": "",
        color: "primary",
        "base-color": "primary",
        density: "compact"
      }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
    ]),
    (_ctx.fetchLoading)
      ? (_openBlock(), _createBlock(_component_vue_loading, {
          key: 0,
          loader: "bars",
          active: _ctx.fetchLoading,
          color: "#EE6090",
          size: { width: '30px', height: '30px' }
        }, null, 8, ["active"]))
      : (_openBlock(), _createBlock(_component_v_list, {
          key: 1,
          density: "compact"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoices, (i, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: i.year + index
              }, [
                _createVNode(_component_v_list_item, {
                  onClick: ($event: any) => (_ctx.toDetail(i.oldOrder))
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_avatar, { class: "ml-2" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_img, {
                          src: 
                  _ctx.selectedChildImg
                    ? _ctx.selectedChildImg
                    : 'https://via.placeholder.com/240x180?text=Sample+Image+1'
                
                        }, null, 8, ["src"])
                      ]),
                      _: 1
                    })
                  ]),
                  append: _withCtx(() => [
                    _createElementVNode("div", null, [
                      (i.readDate === null)
                        ? (_openBlock(), _createBlock(_component_v_badge, {
                            key: 0,
                            color: "red",
                            dot: "",
                            inline: ""
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.createYearMonth({ year: i.year, month: i.month })), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_v_divider)
              ], 64))
            }), 128))
          ]),
          _: 1
        }))
  ]))
}